export default __webpack_public_path__ + "static/media/dynamite_explosion.6344de4e.mp3";